const crmTypeSortKey = id => {
  switch (id) {
    case 3: // Customer
      return 0;
    case 2: // Prospect
      return 1;
    case 4: // Own company
      return 2;
    case 0: // Other
      return 3;
    default:
      // Unknown
      return 9;
  }
};
export const crmTypeSorter = ({ id: a }, { id: b }) => {
  const sortA = crmTypeSortKey(a);
  const sortB = crmTypeSortKey(b);

  return sortA < sortB ? -1 : sortA > sortB;
};

export default { crmType: crmTypeSorter };
